// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const OP: IClientSubSystemModel = {
  Code: 'OP',
  DisplayLabel: 'Organisationer/Personer/Lokaler',
  BusinessModels: {
    OPAdress: {
      CollectionName: 'OPAdress',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Adress',
        Abstract: false,
        SOLabel: 'Adress',
        SOGLabel: 'Adress',
        SBLabel: 'Adressen',
        SBGLabel: 'Adressen',
        POLabel: 'Adresser',
        POGLabel: 'Adresser',
        PBLabel: 'Adresserna',
        PBGLabel: 'Adresserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Adressen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Adressen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Adressen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Adressen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CO: {
          AttributeName: 'CO',
          DisplayLabel: 'C/O',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Postadress',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ADRESS: {
          AttributeName: 'ADRESS',
          DisplayLabel: 'Gatuadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'StreetNames=" True"',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Postadress',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        POSTNR: {
          AttributeName: 'POSTNR',
          DisplayLabel: 'Postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPostNr',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Postadress',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ORT: {
          AttributeName: 'ORT',
          DisplayLabel: 'Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'LowerCase="False";Words=" False"',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Postadress',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        LAND_ID: {
          AttributeName: 'LAND_ID',
          DisplayLabel: 'Land',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Postadress',
        },
        TELEFON1: {
          AttributeName: 'TELEFON1',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTelNr',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Telefon',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TELEFON2: {
          AttributeName: 'TELEFON2',
          DisplayLabel: 'Telefon 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTelNr',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Telefon',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TELEFON_ARB: {
          AttributeName: 'TELEFON_ARB',
          DisplayLabel: 'Telefon arbete',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTelNr',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Telefon',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TELEFON_MOBIL: {
          AttributeName: 'TELEFON_MOBIL',
          DisplayLabel: 'Mobiltelefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTelNr',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Telefon',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TELEFAX: {
          AttributeName: 'TELEFAX',
          DisplayLabel: 'Fax',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTelNr',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Telefon',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        PERSONSOKARE: {
          AttributeName: 'PERSONSOKARE',
          DisplayLabel: 'Personsökare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTelNr',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Telefon',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SMTP1: {
          AttributeName: 'SMTP1',
          DisplayLabel: 'Epost',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SMTP2: {
          AttributeName: 'SMTP2',
          DisplayLabel: 'Epost 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SMTP3: {
          AttributeName: 'SMTP3',
          DisplayLabel: 'Epost 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SMTP4: {
          AttributeName: 'SMTP4',
          DisplayLabel: 'Epost 4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        URL1: {
          AttributeName: 'URL1',
          DisplayLabel: 'Internetadress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        URL2: {
          AttributeName: 'URL2',
          DisplayLabel: 'Internetadress 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        URL3: {
          AttributeName: 'URL3',
          DisplayLabel: 'Internetadress 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        URL4: {
          AttributeName: 'URL4',
          DisplayLabel: 'Internetadress 4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FASTIGHETSBETECKNING: {
          AttributeName: 'FASTIGHETSBETECKNING',
          DisplayLabel: 'Fastighetsbeteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övrigt',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KompaktAdress: {
          AttributeName: 'KompaktAdress',
          DisplayLabel: 'Adressetikett',
          Hint: 'Fullständig adress på flera rader',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'ADRESS|CO|POSTNR|ORT|Land.BENAMNING;'], ['WordAttribute', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KompaktAdressRad: {
          AttributeName: 'KompaktAdressRad',
          DisplayLabel: 'Adress',
          Hint: 'Fullständig adress på en rad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'ADRESS|CO|POSTNR|ORT|Land.BENAMNING;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Postadress: {
          AttributeName: 'Postadress',
          DisplayLabel: 'Postadress',
          Hint: 'Postnr och ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Postadress',
          Properties: new Map([['ConditionAttributes', 'POSTNR|ORT;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Land: {
          AttributeName: 'Land',
          DisplayLabel: 'Land',
          Hint: 'Landsnamn om annat än Sverige',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'Land.LANDKOD|Land.BENAMNING']]),
        },
        ADRESS2: {
          AttributeName: 'ADRESS2',
          DisplayLabel: 'Adress 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ADRESS3: {
          AttributeName: 'ADRESS3',
          DisplayLabel: 'Adress 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ADRESS1: {
          AttributeName: 'ADRESS1',
          DisplayLabel: 'Adress 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        CO_ADRESS: {
          AttributeName: 'CO_ADRESS',
          DisplayLabel: 'C/O adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AdressTelefon: {
          AttributeName: 'AdressTelefon',
          DisplayLabel: 'Adress och telefon (etikett)',
          Hint: 'Adress och telefon på flera rader',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'ADRESS|CO|POSTNR|ORT|Land.BENAMNING|TELEFON1;'], ['WordAttribute', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AdressTelefonRad: {
          AttributeName: 'AdressTelefonRad',
          DisplayLabel: 'Adress och telefon',
          Hint: 'Adress och telefon på en rad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'ADRESS|CO|POSTNR|ORT|Land.BENAMNING|TELEFON1;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AdressSkydd: {
          AttributeName: 'AdressSkydd',
          DisplayLabel: 'Skyddad adress',
          Hint: 'Normal/Skyddad',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['SKYDDAD', 'Skyddad']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['SKYDDAD', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;SKYDDAD=Skyddad"',
        },
        KompaktAdress2: {
          AttributeName: 'KompaktAdress2',
          DisplayLabel: 'Adress',
          Hint: 'Fullständig adress på flera rader',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'ADRESS|POSTNR|ORT|Land.BENAMNING;'], ['WordAttribute', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AdressTelefonMobil: {
          AttributeName: 'AdressTelefonMobil',
          DisplayLabel: 'Adress, telefon och mobil (etikett)',
          Hint: 'Adress, telefon och mobil på en rad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'ADRESS|CO|POSTNR|ORT|Land.BENAMNING|TELEFON1|TELEFON_MOBIL;'], ['WordAttribute', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AdressTelefonMobilEpost: {
          AttributeName: 'AdressTelefonMobilEpost',
          DisplayLabel: 'Adress, telefon, mobil och epost (etikett)',
          Hint: 'Adress, telefon, mobil och epost på en rad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'ADRESS|CO|POSTNR|ORT|Land.BENAMNING|TELEFON1|TELEFON_MOBIL|SMTP1;'], ['WordAttribute', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        HANTERAD: {
          AttributeName: 'HANTERAD',
          DisplayLabel: 'Hanterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HANTERAD_DATUM: {
          AttributeName: 'HANTERAD_DATUM',
          DisplayLabel: 'Hanterad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AvvikandeAdress: {
          AttributeName: 'AvvikandeAdress',
          DisplayLabel: 'Adress som inte uppdateras',
          Hint: 'Uppdateras/Lokal',
          DataType: 'Enum',
          EnumValues: new Map([['UPPDATERAS', 'Uppdateras'], ['LOKAL', 'Lokal']]),
          EnumSortValues: new Map([['UPPDATERAS', 'N'], ['LOKAL', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UPPDATERAS=Uppdateras;LOKAL=Lokal"',
        },
        SENAST_TEL_DATUM: {
          AttributeName: 'SENAST_TEL_DATUM',
          DisplayLabel: 'Datum ändrat telefonnr',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTimeGeneral',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SENAST_EPOST_DATUM: {
          AttributeName: 'SENAST_EPOST_DATUM',
          DisplayLabel: 'Datum ändrad epost',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTimeGeneral',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        MobilEllerTelefon: {
          AttributeName: 'MobilEllerTelefon',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KompaktAdressCO: {
          AttributeName: 'KompaktAdressCO',
          DisplayLabel: 'Adressetikett C/O',
          Hint: 'Fullständig adress på flera rader',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'ADRESS|CO|POSTNR|ORT|Land.BENAMNING;'], ['WordAttribute', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AdressCO: {
          AttributeName: 'AdressCO',
          DisplayLabel: 'Gatuadress inkl. C/O',
          Hint: 'Postnr och ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'ADRESS|CO;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Land: {
          AssociationName: 'Land',
          DisplayLabel: 'Land',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        OrgPersLok: {
          AssociationName: 'OrgPersLok',
          DisplayLabel: 'Organisationer/Personer/Lokaler',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPersLok',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['OPL_NOCOMBINE', 'True']]),
        },
        Kontakter: {
          AssociationName: 'Kontakter',
          DisplayLabel: 'Kontaktpersonadresser',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPKontakt',
          AssociatedComponentName: 'Kontakt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OPOrgPersLok: {
      CollectionName: 'OPOrgPersLok',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['CANSELECTDELETED', 'Y'], ['USER_DEF_REPORT_ROUTINE', '8004'], ['ExcludeClassOnAssignType', 'Y'], ['AllowEdit', '8001,8002,8003,8004,8008,1013']]),
      RootType: {
        TypeValue: 'OrgPersLok',
        Abstract: true,
        SOLabel: 'Adress/Lokal',
        SOGLabel: 'Adress/Lokal',
        SBLabel: 'Adressen/Lokalen',
        SBGLabel: 'Adressen/Lokalen',
        POLabel: 'Adresser/Lokaler',
        POGLabel: 'Adresser/Lokaler',
        PBLabel: 'Adresserna/Lokalerna',
        PBGLabel: 'Adresserna/Lokalerna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'OrgPers',
            Abstract: true,
            SOLabel: 'Adress',
            SOGLabel: 'Adress',
            SBLabel: 'Adressen',
            SBGLabel: 'Adressen',
            POLabel: 'Adresser',
            POGLabel: 'Adresser',
            PBLabel: 'Adresserna',
            PBGLabel: 'Adresserna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Organisation',
                Abstract: true,
                SOLabel: 'Organisation',
                SOGLabel: 'Organisations',
                SBLabel: 'Organisationen',
                SBGLabel: 'Organisationens',
                POLabel: 'Organisationer',
                POGLabel: 'Organisationers',
                PBLabel: 'Organisationerna',
                PBGLabel: 'Organisationernas',
                Visible: true,
                ChildTypes: [
                  {
                    TypeValue: 'SamfallighetForsamling',
                    Abstract: true,
                    SOLabel: 'Pastorat/församling',
                    SOGLabel: 'Pastorat/församling',
                    SBLabel: 'Pastoratet/församlingen',
                    SBGLabel: 'Pastoratet/församlingen',
                    POLabel: 'Pastorat/församlingar',
                    POGLabel: 'Pastorat/församlingar',
                    PBLabel: 'Pastoraten/församlingarna',
                    PBGLabel: 'Pastoraten/församlingarna',
                    Visible: true,
                    ChildTypes: [
                      {
                        TypeValue: 'Forsamling',
                        Abstract: false,
                        SOLabel: 'Församling',
                        SOGLabel: 'Församling',
                        SBLabel: 'Församlingen',
                        SBGLabel: 'Församlingen',
                        POLabel: 'Församlingar',
                        POGLabel: 'Församlingar',
                        PBLabel: 'Församlingarna',
                        PBGLabel: 'Församlingarna',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'Samfallighet',
                        Abstract: false,
                        SOLabel: 'Flerförsamlingspastorat',
                        SOGLabel: 'Flerförsamlingspastorat',
                        SBLabel: 'Flerförsamlingspastoratet',
                        SBGLabel: 'Flerförsamlingspastoratet',
                        POLabel: 'Flerförsamlingspastorat',
                        POGLabel: 'Flerförsamlingspastorat',
                        PBLabel: 'Flerförsamlingspastoraten',
                        PBGLabel: 'Flerförsamlingspastoraten',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                    ],
                  },
                  {
                    TypeValue: 'OvrigOrg',
                    Abstract: false,
                    SOLabel: 'Övrig organisation',
                    SOGLabel: 'Övrig organisations',
                    SBLabel: 'Övrig organisationen',
                    SBGLabel: 'Övrig organisationens',
                    POLabel: 'Övriga organisationer',
                    POGLabel: 'Övriga organisationers',
                    PBLabel: 'Övriga organisationerna',
                    PBGLabel: 'Övriga organisationernas',
                    Visible: true,
                    ChildTypes: [
                    ],
                  },
                ],
              },
              {
                TypeValue: 'Person',
                Abstract: false,
                SOLabel: 'Person',
                SOGLabel: 'Person',
                SBLabel: 'Personen',
                SBGLabel: 'Personen',
                POLabel: 'Personer',
                POGLabel: 'Personer',
                PBLabel: 'Personerna',
                PBGLabel: 'Personerna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'Lokal',
            Abstract: false,
            SOLabel: 'Lokal',
            SOGLabel: 'Lokal',
            SBLabel: 'Lokalen',
            SBGLabel: 'Lokalen',
            POLabel: 'Lokaler',
            POGLabel: 'Lokaler',
            PBLabel: 'Lokalerna',
            PBGLabel: 'Lokalerna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Adressen/Lokalen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Adressen/Lokalen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ av adress',
          DataType: 'Enum',
          EnumValues: new Map([['FORSAMLING', 'Församling'], ['SAMFALLIGHET', 'Flerförsamlingspastorat'], ['OVRIGORG', 'Övrig organisation'], ['PERSON', 'Person'], ['LOKAL', 'Lokal']]),
          EnumSortValues: new Map([['FORSAMLING', 'F'], ['SAMFALLIGHET', 'S'], ['OVRIGORG', 'O'], ['PERSON', 'P'], ['LOKAL', 'L']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Adressen/Lokalen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Adressen/Lokalen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ADR_ID: {
          AttributeName: 'ADR_ID',
          DisplayLabel: 'Adress',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SORTERINGSNAMN: {
          AttributeName: 'SORTERINGSNAMN',
          DisplayLabel: 'Sorteringsnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        LOKALADR: {
          AttributeName: 'LOKALADR',
          DisplayLabel: 'Lokaladress',
          Hint: 'Extern/Lokal',
          DataType: 'Enum',
          EnumValues: new Map([['EXTERN', 'Extern'], ['LOKAL', 'Lokal']]),
          EnumSortValues: new Map([['EXTERN', 'N'], ['LOKAL', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EXTERN=Extern;LOKAL=Lokal"',
        },
        LOKALADR_RUBRIK: {
          AttributeName: 'LOKALADR_RUBRIK',
          DisplayLabel: 'Lokaladress rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REF_OPL_ID: {
          AttributeName: 'REF_OPL_ID',
          DisplayLabel: 'Referens Org/Person',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTECKNINGAR: {
          AttributeName: 'ANTECKNINGAR',
          DisplayLabel: 'Anteckningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        UPD_ID: {
          AttributeName: 'UPD_ID',
          DisplayLabel: 'ID för automatisk uppdatering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPD_PERS_NR: {
          AttributeName: 'UPD_PERS_NR',
          DisplayLabel: 'Personnummer för automatisk uppdatering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_ORSAK: {
          AttributeName: 'BORTTAGEN_ORSAK',
          DisplayLabel: 'Borttagen orsak',
          Hint: 'Avliden/Borttagen/Skyddad',
          DataType: 'Enum',
          EnumValues: new Map([['AVLIDEN', 'Avliden'], ['BORTTAGEN', 'Borttagen'], ['SKYDDAD', 'Skyddad']]),
          EnumSortValues: new Map([['AVLIDEN', 'B'], ['BORTTAGEN', 'O'], ['SKYDDAD', 'S']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVLIDEN=Avliden;BORTTAGEN=Borttagen;SKYDDAD=Skyddad"',
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Borttagen',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TRIGGER_DATUM: {
          AttributeName: 'TRIGGER_DATUM',
          DisplayLabel: 'Trigger datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SEN_ANDR_DATUM: {
          AttributeName: 'SEN_ANDR_DATUM',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANDRAD_AV_ANV_TIMESTAMP: {
          AttributeName: 'ANDRAD_AV_ANV_TIMESTAMP',
          DisplayLabel: 'Ändrad av användare',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LAND_ID: {
          AttributeName: 'LAND_ID',
          DisplayLabel: 'Land',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['OrgPers'],
        },
        LKF: {
          AttributeName: 'LKF',
          DisplayLabel: 'LKF-kod, gravsättningsort',
          Hint: 'Län, Kommun, Församling',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['OrgPers'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KYRKOLKF: {
          AttributeName: 'KYRKOLKF',
          DisplayLabel: 'Kyrkolkf',
          Hint: 'Tillhörig i län/kommun/församling',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['OrgPers'],
          AttributeGroup: 'Person',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        LKF_BENAMNING: {
          AttributeName: 'LKF_BENAMNING',
          DisplayLabel: 'Hemort (LKF)',
          Hint: 'Län, Kommun, Församling',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['OrgPers'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KYRKOLKF_BENAMNING: {
          AttributeName: 'KYRKOLKF_BENAMNING',
          DisplayLabel: 'Kyrkolkf benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['OrgPers'],
          AttributeGroup: 'Person',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FORNAMN: {
          AttributeName: 'FORNAMN',
          DisplayLabel: 'Förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'PersNames="Y"',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ORG_NR: {
          AttributeName: 'ORG_NR',
          DisplayLabel: 'Organisationsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatOrgNr',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Organisation'],
        },
        ORG_NAMN: {
          AttributeName: 'ORG_NAMN',
          DisplayLabel: 'Organisationsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'OrgNames=" True"',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Organisation'],
        },
        MOMSREG_NR: {
          AttributeName: 'MOMSREG_NR',
          DisplayLabel: 'Momsregistreringsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Organisation'],
          AttributeGroup: 'Organisation',
        },
        KATEGORI: {
          AttributeName: 'KATEGORI',
          DisplayLabel: 'Kategori',
          Hint: 'Begravningsbyrå/Intern - Begravningsbyrå/Intern/Kyrklig enhet/Stift',
          DataType: 'Enum',
          EnumValues: new Map([['BEGRAVNINGSBYRA', 'Begravningsbyrå'], ['INTERN', 'Intern'], ['KYRKLIG_ENHET', 'Kyrklig enhet'], ['STIFT', 'Stift']]),
          EnumSortValues: new Map([['BEGRAVNINGSBYRA', 'B'], ['INTERN', 'I'], ['KYRKLIG_ENHET', 'K'], ['STIFT', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BEGRAVNINGSBYRA=Begravningsbyrå;INTERN=Intern;KYRKLIG_ENHET=Kyrklig enhet;STIFT=Stift"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          ValidInComps: ['Organisation'],
          AttributeGroup: 'Organisation',
        },
        SAMFALLIGHET_ID: {
          AttributeName: 'SAMFALLIGHET_ID',
          DisplayLabel: 'Flerförsamlingspastorat',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Forsamling'],
        },
        EGEN_EKONOMI: {
          AttributeName: 'EGEN_EKONOMI',
          DisplayLabel: 'Egen ekonomi',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['Forsamling'],
          AttributeGroup: 'Församling',
        },
        INVANARE_ANTAL: {
          AttributeName: 'INVANARE_ANTAL',
          DisplayLabel: 'Invånarantal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Forsamling'],
          AttributeGroup: 'Församling',
        },
        MEDLEM_ANTAL: {
          AttributeName: 'MEDLEM_ANTAL',
          DisplayLabel: 'Antal tillhöriga',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Forsamling'],
          AttributeGroup: 'Församling',
        },
        SAMFKOD: {
          AttributeName: 'SAMFKOD',
          DisplayLabel: 'Pastoratskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 6,
          ValidInComps: ['SamfallighetForsamling'],
          AttributeGroup: 'Pastorat',
        },
        FAKTURERA_SAMFALLIGHET: {
          AttributeName: 'FAKTURERA_SAMFALLIGHET',
          DisplayLabel: 'Fakturera pastoratet',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Samfallighet'],
          AttributeGroup: 'Samfällighet',
        },
        PERS_NR: {
          AttributeName: 'PERS_NR',
          DisplayLabel: 'Personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPersNr',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        EFTERNAMN: {
          AttributeName: 'EFTERNAMN',
          DisplayLabel: 'Efternamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'PersNames=" True"',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Person'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        MELLANNAMN: {
          AttributeName: 'MELLANNAMN',
          DisplayLabel: 'Mellannamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'PersNames=" True"',
          ValidInComps: ['Person'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FULLST_FORNAMN: {
          AttributeName: 'FULLST_FORNAMN',
          DisplayLabel: 'Förnamn, fullständigt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        VARDNADSHAVARE1: {
          AttributeName: 'VARDNADSHAVARE1',
          DisplayLabel: 'Vårdnadshavare 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
        },
        VARDNADSHAVARE2: {
          AttributeName: 'VARDNADSHAVARE2',
          DisplayLabel: 'Vårdnadshavare 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
        },
        RELATIONSPERSON: {
          AttributeName: 'RELATIONSPERSON',
          DisplayLabel: 'Relationsperson',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
        },
        MEDLEMSKOD: {
          AttributeName: 'MEDLEMSKOD',
          DisplayLabel: 'Medlemskod',
          Hint: 'Tillhörig Svenska kyrkan/Utträdd ur Svenska kyrkan/Antecknad i avvaktan på dop/Antecknad i avvaktan på meddelande/Utträdd men antecknad pga kyrkotillhörigt barn eller pga samtycke/Antecknad vårdnadshavare/Utträdd p.g.a. utvandring/Borttagen uppgift om Antecknad/Ej tillhörig Svenska kyrkan/Uppgift saknas',
          DataType: 'Enum',
          EnumValues: new Map([['TILLHORIG_SVENSKA_KYRKAN', 'Tillhörig Svenska kyrkan'], ['UTTRADD_UR_SVENSKA_KYRKAN', 'Utträdd ur Svenska kyrkan'], ['ANTECKNAD_I_AVVAKTAN_PA_DOP', 'Antecknad i avvaktan på dop'], ['ANTECKNAD_I_AVVAKTAN_PA_MEDDELANDE', 'Antecknad i avvaktan på meddelande'], ['UTTRADD_MEN_ANTECKNAD_PGA_KYRKOTILLHORIGT_BARN_ELLER_PGA_SAMTYCKE', 'Utträdd men antecknad pga kyrkotillhörigt barn eller pga samtycke'], ['ANTECKNAD_VARDNADSHAVARE', 'Antecknad vårdnadshavare'], ['UTTRADD_P_G_A__UTVANDRING', 'Utträdd p.g.a. utvandring'], ['BORTTAGEN_UPPGIFT_OM_ANTECKNAD', 'Borttagen uppgift om Antecknad'], ['EJ_TILLHORIG_SVENSKA_KYRKAN', 'Ej tillhörig Svenska kyrkan'], ['UPPGIFT_SAKNAS', 'Uppgift saknas']]),
          EnumSortValues: new Map([['TILLHORIG_SVENSKA_KYRKAN', 'I'], ['UTTRADD_UR_SVENSKA_KYRKAN', 'U'], ['ANTECKNAD_I_AVVAKTAN_PA_DOP', 'AD'], ['ANTECKNAD_I_AVVAKTAN_PA_MEDDELANDE', 'AM'], ['UTTRADD_MEN_ANTECKNAD_PGA_KYRKOTILLHORIGT_BARN_ELLER_PGA_SAMTYCKE', 'AU'], ['ANTECKNAD_VARDNADSHAVARE', 'AV'], ['UTTRADD_P_G_A__UTVANDRING', 'UU'], ['BORTTAGEN_UPPGIFT_OM_ANTECKNAD', 'B'], ['EJ_TILLHORIG_SVENSKA_KYRKAN', 'N'], ['UPPGIFT_SAKNAS', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TILLHORIG_SVENSKA_KYRKAN=Tillhörig Svenska kyrkan;UTTRADD_UR_SVENSKA_KYRKAN=Utträdd ur Svenska kyrkan;ANTECKNAD_I_AVVAKTAN_PA_DOP=Antecknad i avvaktan på dop;ANTECKNAD_I_AVVAKTAN_PA_MEDDELANDE=Antecknad i avvaktan på meddelande;UTTRADD_MEN_ANTECKNAD_PGA_KYRKOTILLHORIGT_BARN_ELLER_PGA_SAMTYCKE=Utträdd men antecknad pga kyrkotillhörigt barn eller pga samtycke;ANTECKNAD_VARDNADSHAVARE=Antecknad vårdnadshavare;UTTRADD_P_G_A__UTVANDRING=Utträdd p.g.a. utvandring;BORTTAGEN_UPPGIFT_OM_ANTECKNAD=Borttagen uppgift om Antecknad;EJ_TILLHORIG_SVENSKA_KYRKAN=Ej tillhörig Svenska kyrkan;UPPGIFT_SAKNAS=Uppgift saknas"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
        },
        MEDLEMSDATUM: {
          AttributeName: 'MEDLEMSDATUM',
          DisplayLabel: 'Medlemsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['Person'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        DOPKOD: {
          AttributeName: 'DOPKOD',
          DisplayLabel: 'Döpt',
          Hint: 'I Svenska kyrkans ordning/I annan kristen kyrkas ordning/Nej/Uppgift saknas',
          DataType: 'Enum',
          EnumValues: new Map([['I_SVENSKA_KYRKANS_ORDNING', 'I Svenska kyrkans ordning'], ['I_ANNAN_KRISTEN_KYRKAS_ORDNING', 'I annan kristen kyrkas ordning'], ['NEJ', 'Nej'], ['UPPGIFT_SAKNAS', 'Uppgift saknas']]),
          EnumSortValues: new Map([['I_SVENSKA_KYRKANS_ORDNING', 'D'], ['I_ANNAN_KRISTEN_KYRKAS_ORDNING', 'A'], ['NEJ', 'N'], ['UPPGIFT_SAKNAS', 'S']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="I_SVENSKA_KYRKANS_ORDNING=I Svenska kyrkans ordning;I_ANNAN_KRISTEN_KYRKAS_ORDNING=I annan kristen kyrkas ordning;NEJ=Nej;UPPGIFT_SAKNAS=Uppgift saknas"',
          ValidInComps: ['Person'],
        },
        DOPDATUM: {
          AttributeName: 'DOPDATUM',
          DisplayLabel: 'Dopdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['Person'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KONF_KOD: {
          AttributeName: 'KONF_KOD',
          DisplayLabel: 'Konfirmerad',
          Hint: 'I Svenska kyrkans ordning/I annan kristen kyrkas ordning/Nej/Uppgift saknas',
          DataType: 'Enum',
          EnumValues: new Map([['I_SVENSKA_KYRKANS_ORDNING', 'I Svenska kyrkans ordning'], ['I_ANNAN_KRISTEN_KYRKAS_ORDNING', 'I annan kristen kyrkas ordning'], ['NEJ', 'Nej'], ['UPPGIFT_SAKNAS', 'Uppgift saknas']]),
          EnumSortValues: new Map([['I_SVENSKA_KYRKANS_ORDNING', 'K'], ['I_ANNAN_KRISTEN_KYRKAS_ORDNING', 'A'], ['NEJ', 'N'], ['UPPGIFT_SAKNAS', 'S']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="I_SVENSKA_KYRKANS_ORDNING=I Svenska kyrkans ordning;I_ANNAN_KRISTEN_KYRKAS_ORDNING=I annan kristen kyrkas ordning;NEJ=Nej;UPPGIFT_SAKNAS=Uppgift saknas"',
          ValidInComps: ['Person'],
        },
        KONF_DATUM: {
          AttributeName: 'KONF_DATUM',
          DisplayLabel: 'Konfirmationsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['Person'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        CIVILSTAND: {
          AttributeName: 'CIVILSTAND',
          DisplayLabel: 'Civilstånd',
          Hint: 'Gift/Ogift/Registrerad partner/Änka/änkling/Skild',
          DataType: 'Enum',
          EnumValues: new Map([['GIFT', 'Gift'], ['OGIFT', 'Ogift'], ['REGISTRERAD_PARTNER', 'Registrerad partner'], ['ANKA_ANKLING', 'Änka/änkling'], ['SKILD', 'Skild']]),
          EnumSortValues: new Map([['GIFT', 'G'], ['OGIFT', 'OG'], ['REGISTRERAD_PARTNER', 'RP'], ['ANKA_ANKLING', 'Ä'], ['SKILD', 'S']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GIFT=Gift;OGIFT=Ogift;REGISTRERAD_PARTNER=Registrerad partner;ANKA_ANKLING=Änka/änkling;SKILD=Skild"',
          ValidInComps: ['Person'],
        },
        CIVIL_DATUM: {
          AttributeName: 'CIVIL_DATUM',
          DisplayLabel: 'Civilstånd senast ändrat',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['Person'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FORNAMN_1: {
          AttributeName: 'FORNAMN_1',
          DisplayLabel: 'Förnamn 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
          Properties: new Map([['ffIgnoreChanges', 'Y;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FORNAMN_2: {
          AttributeName: 'FORNAMN_2',
          DisplayLabel: 'Förnamn 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
          Properties: new Map([['ffIgnoreChanges', 'Y;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FORNAMN_3: {
          AttributeName: 'FORNAMN_3',
          DisplayLabel: 'Förnamn 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
          Properties: new Map([['ffIgnoreChanges', 'Y;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FORNAMN_4: {
          AttributeName: 'FORNAMN_4',
          DisplayLabel: 'Förnamn 4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
          Properties: new Map([['ffIgnoreChanges', 'Y;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FORNAMN_5: {
          AttributeName: 'FORNAMN_5',
          DisplayLabel: 'Förnamn 5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
          Properties: new Map([['ffIgnoreChanges', 'Y;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SORT_EFTERNAMN: {
          AttributeName: 'SORT_EFTERNAMN',
          DisplayLabel: 'Sortering, Efternamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
          Properties: new Map([['ffIgnoreChanges', 'Y;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SORT_MELLANNAMN: {
          AttributeName: 'SORT_MELLANNAMN',
          DisplayLabel: 'Sortering, Mellannamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
          Properties: new Map([['ffIgnoreChanges', 'Y;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AUTO_ADRESS_UPDAT: {
          AttributeName: 'AUTO_ADRESS_UPDAT',
          DisplayLabel: 'Uppdateras automatiskt',
          Hint: 'Skall uppdateras/Skall inte uppdateras',
          DataType: 'Enum',
          EnumValues: new Map([['SKALL_UPPDATERAS', 'Skall uppdateras'], ['SKALL_INTE_UPPDATERAS', 'Skall inte uppdateras']]),
          EnumSortValues: new Map([['SKALL_UPPDATERAS', 'Y'], ['SKALL_INTE_UPPDATERAS', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKALL_UPPDATERAS=Skall uppdateras;SKALL_INTE_UPPDATERAS=Skall inte uppdateras"',
          ValidInComps: ['Person'],
        },
        KNAV_ADRESS_STATUS: {
          AttributeName: 'KNAV_ADRESS_STATUS',
          DisplayLabel: 'KNAV_ADRESS_STATUS',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'Words=" False"',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Lokal'],
          AttributeGroup: 'Lokal',
        },
        TypNamn: {
          AttributeName: 'TypNamn',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Rubrik: {
          AttributeName: 'Rubrik',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn',
          Hint: 'Organisationsnamn eller Efterrnamn, Förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'OP_Namn|FORNAMN;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnFE: {
          AttributeName: 'NamnFE',
          DisplayLabel: 'Namn (förnamn efternamn)',
          Hint: 'Organisationsnamn eller Förnamn Efternamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'OP_Namn|FORNAMN;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnFFE: {
          AttributeName: 'NamnFFE',
          DisplayLabel: 'Namn (fullständigt förnamn efternamn)',
          Hint: 'Organisationsnamn eller Förnamn Efternamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        NamnAdress: {
          AttributeName: 'NamnAdress',
          DisplayLabel: 'Namn och adress (etikett)',
          Hint: 'Namn och adress på flera rader',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'OP_Namn|FORNAMN|Adress.ADRESS|Adress.CO|Adress.POSTNR|Adress.ORT|Adress.Land.BENAMNING;'], ['WordAttribute', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Adress: {
          AttributeName: 'Adress',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['Deprecated', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AdressRad: {
          AttributeName: 'AdressRad',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['Deprecated', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Status: {
          AttributeName: 'Status',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NamnME: {
          AttributeName: 'NamnME',
          DisplayLabel: 'Efternamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['OrgPers'],
          AttributeGroup: 'Person',
          Properties: new Map([['ConditionAttributes', 'OP_Namn;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        OrgNrPersNr: {
          AttributeName: 'OrgNrPersNr',
          DisplayLabel: 'Org.nr/Pers.nr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatOrgNrPersNr',
          ValidInComps: ['OrgPers'],
          Properties: new Map([['ConditionAttributes', 'OP_NR;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Vardnadshavare_1: {
          AttributeName: 'Vardnadshavare_1',
          DisplayLabel: 'Vårdnadshavare 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
        },
        Vardnadshavare_2: {
          AttributeName: 'Vardnadshavare_2',
          DisplayLabel: 'Vårdnadshavare 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Person'],
        },
        SortENamn: {
          AttributeName: 'SortENamn',
          DisplayLabel: 'Sortering, Efternamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SenastAndrad: {
          AttributeName: 'SenastAndrad',
          DisplayLabel: 'Senast ändrad',
          Hint: 'Datum för senaste ändring av adressen',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
        },
        ForsamlingMedlemProcent: {
          AttributeName: 'ForsamlingMedlemProcent',
          DisplayLabel: 'Församlingens medlemsantal i procent',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
          ValidInComps: ['Forsamling'],
          AttributeGroup: 'Församling',
        },
        TillhorSamlighet: {
          AttributeName: 'TillhorSamlighet',
          DisplayLabel: 'Ingår i ett flerförsamlingspastorat',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Forsamling'],
          AttributeGroup: 'Församling',
        },
        AntalInv: {
          AttributeName: 'AntalInv',
          DisplayLabel: 'Invånarantal pastoratet',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Samfallighet'],
          AttributeGroup: 'Samfällighet',
        },
        AntalMedlemmar: {
          AttributeName: 'AntalMedlemmar',
          DisplayLabel: 'Medlemsantal pastoratet',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Samfallighet'],
          AttributeGroup: 'Samfällighet',
        },
        MedlemmarProcent: {
          AttributeName: 'MedlemmarProcent',
          DisplayLabel: 'Medlemsantal i procent',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
          ValidInComps: ['Samfallighet'],
          AttributeGroup: 'Samfällighet',
        },
        Fodelsedatum: {
          AttributeName: 'Fodelsedatum',
          DisplayLabel: 'Födelsedatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'AllowIncomplete="Y"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Fodelsear: {
          AttributeName: 'Fodelsear',
          DisplayLabel: 'Födelseår',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        PersNrKon: {
          AttributeName: 'PersNrKon',
          DisplayLabel: 'Man/Kvinna',
          Hint: 'Kvinna/Man/Okänt',
          DataType: 'Enum',
          EnumValues: new Map([['KVINNA', 'Kvinna'], ['MAN', 'Man'], ['OKANT', 'Okänt']]),
          EnumSortValues: new Map([['KVINNA', 'K'], ['MAN', 'M'], ['OKANT', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KVINNA=Kvinna;MAN=Man;OKANT=Okänt"',
          InterfaceType: 'ifChecklist',
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
        },
        PersNrFullst: {
          AttributeName: 'PersNrFullst',
          DisplayLabel: 'Fullständigt personnummer',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
        },
        Forsamlingsbo: {
          AttributeName: 'Forsamlingsbo',
          DisplayLabel: 'Församlingsbo',
          Hint: 'Tillhör den egna samfälligheten/församlingen - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
        },
        OP_Namn: {
          AttributeName: 'OP_Namn',
          DisplayLabel: 'Namn/Efternamn',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['DisplayLabel', 'TEDOPPerson:Efternamn,TEDOPOrganisation:Namn,TEDOPLokal:Namn;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        OP_NR: {
          AttributeName: 'OP_NR',
          DisplayLabel: 'Org.nr/Pers.nr',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatOrgNrPersNr',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['OrgPers'],
          Properties: new Map([['DisplayLabel', 'TEDOPPerson:Pers.nr,TEDOPOrganisation:Org.nr;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SortNamn: {
          AttributeName: 'SortNamn',
          DisplayLabel: 'Sortering, Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SortFNamn: {
          AttributeName: 'SortFNamn',
          DisplayLabel: 'Sortering, Förnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
          ValidInComps: ['Person'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnAdressTelefon: {
          AttributeName: 'NamnAdressTelefon',
          DisplayLabel: 'Namn, adress och telefon (etikett)',
          Hint: 'Namn, adress och telefon på flera rader',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'OP_Namn|FORNAMN|Adress.ADRESS|Adress.CO|Adress.POSTNR|Adress.ORT|Adress.Land.BENAMNING|Adress.TELEFON1;'], ['WordAttribute', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnAdressRad: {
          AttributeName: 'NamnAdressRad',
          DisplayLabel: 'Namn och adress',
          Hint: 'Namn och adress på en rad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'OP_Namn|FORNAMN|Adress.ADRESS|Adress.CO|Adress.POSTNR|Adress.ORT|Adress.Land.BENAMNING;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnAdressTelefonRad: {
          AttributeName: 'NamnAdressTelefonRad',
          DisplayLabel: 'Namn, adress och telefon',
          Hint: 'Namn, adress och telefon på en rad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'OP_Namn|FORNAMN|Adress.ADRESS|Adress.CO|Adress.POSTNR|Adress.ORT|Adress.Land.BENAMNING|Adress.TELEFON1;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        LKFStatus: {
          AttributeName: 'LKFStatus',
          DisplayLabel: 'LKF-status',
          Hint: 'Hemförsamling/Egen kod/Övriga',
          DataType: 'Enum',
          EnumValues: new Map([['HEMFORSAMLING', 'Hemförsamling'], ['EGEN_KOD', 'Egen kod'], ['OVRIGA', 'Övriga']]),
          EnumSortValues: new Map([['HEMFORSAMLING', 'H'], ['EGEN_KOD', 'E'], ['OVRIGA', 'X']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HEMFORSAMLING=Hemförsamling;EGEN_KOD=Egen kod;OVRIGA=Övriga"',
          InterfaceType: 'ifChecklist',
          ValidInComps: ['OrgPers'],
        },
        FullstFornamn: {
          AttributeName: 'FullstFornamn',
          DisplayLabel: 'Förnamn, fullständigt eller tilltalsnamn',
          Hint: 'Fullständigt förnamn om det finns, annars tilltalsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SKYDDAD: {
          AttributeName: 'SKYDDAD',
          DisplayLabel: 'Skyddad person',
          Hint: 'Normal/Skyddad',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['SKYDDAD', 'Skyddad']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['SKYDDAD', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;SKYDDAD=Skyddad"',
        },
        KBLevkostKonto: {
          AttributeName: 'KBLevkostKonto',
          DisplayLabel: 'KBLevkostKonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KyrkoForsamlingsbo: {
          AttributeName: 'KyrkoForsamlingsbo',
          DisplayLabel: 'Kyrko församlingsbo',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Person',
        },
        ClearingLKF: {
          AttributeName: 'ClearingLKF',
          DisplayLabel: 'ClearingLKF',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        StatligClearingLKF: {
          AttributeName: 'StatligClearingLKF',
          DisplayLabel: 'StatligClearingLKF',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ADRESS_SOURCE: {
          AttributeName: 'ADRESS_SOURCE',
          DisplayLabel: 'Källa för adress',
          Hint: 'Skatteverket',
          DataType: 'Enum',
          EnumValues: new Map([['SKATTEVERKET', 'Skatteverket']]),
          EnumSortValues: new Map([['SKATTEVERKET', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKATTEVERKET=Skatteverket"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        LKF2: {
          AttributeName: 'LKF2',
          DisplayLabel: 'LKF2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        DODSDATUM: {
          AttributeName: 'DODSDATUM',
          DisplayLabel: 'Dödsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnAdressTelefonMobilEpost: {
          AttributeName: 'NamnAdressTelefonMobilEpost',
          DisplayLabel: 'Namn, adress, telefon, mobil och epost (etikett)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConditionAttributes', 'OP_Namn|FORNAMN|Adress.ADRESS|Adress.CO|Adress.POSTNR|Adress.ORT|Adress.Land.BENAMNING|Adress.TELEFON1'], ['Adress.TELEFON_MOBIL|Adress.SMTP1;', ''], ['WordAttribute', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ANVANDNING_ID: {
          AttributeName: 'ANVANDNING_ID',
          DisplayLabel: 'Adressanvändning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        AVVIKANDE: {
          AttributeName: 'AVVIKANDE',
          DisplayLabel: 'Avvikande adress',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RENSA_PA_BEGARAN: {
          AttributeName: 'RENSA_PA_BEGARAN',
          DisplayLabel: 'Rensa på begäran',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="å=12;m=1";DefaultGroup="å";GroupTexts="å=å;år=å;m=m;mån=m;månad=m;månader=m"',
          FormatterDisplayParams: 'Groups="år=12;månader/månad=1";GroupNameSep=" "',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TimeToClear: {
          AttributeName: 'TimeToClear',
          DisplayLabel: 'Tid för rensning',
          Hint: 'Rensas en bestämd tid efter referensdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        GALLRAD: {
          AttributeName: 'GALLRAD',
          DisplayLabel: 'Gallrad',
          Hint: 'Nej/Ja/Preliminärt',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja'], ['PRELIMINART', 'Preliminärt']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y'], ['PRELIMINART', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja;PRELIMINART=Preliminärt"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REGEL: {
          AttributeName: 'REGEL',
          DisplayLabel: 'Regel för rensning',
          Hint: 'Standard/Direkt',
          DataType: 'Enum',
          EnumValues: new Map([['STANDARD', 'Standard'], ['DIREKT', 'Direkt']]),
          EnumSortValues: new Map([['STANDARD', 'S'], ['DIREKT', 'D']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STANDARD=Standard;DIREKT=Direkt"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FORNAMN_FRAN_SKV: {
          AttributeName: 'FORNAMN_FRAN_SKV',
          DisplayLabel: 'Förnamn från Skatteverket',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AVLIDEN_STATUS: {
          AttributeName: 'AVLIDEN_STATUS',
          DisplayLabel: 'Avlidens status fr. SKV',
          Hint: 'Avliden/Preliminärt avliden',
          DataType: 'Enum',
          EnumValues: new Map([['AVLIDEN', 'Avliden'], ['PRELIMINART_AVLIDEN', 'Preliminärt avliden']]),
          EnumSortValues: new Map([['AVLIDEN', 'A'], ['PRELIMINART_AVLIDEN', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVLIDEN=Avliden;PRELIMINART_AVLIDEN=Preliminärt avliden"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HISTORISK: {
          AttributeName: 'HISTORISK',
          DisplayLabel: 'Historisk uppgift',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GALLRAD_DATUM: {
          AttributeName: 'GALLRAD_DATUM',
          DisplayLabel: 'Gallrad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AnvandsAv: {
          AttributeName: 'AnvandsAv',
          DisplayLabel: 'Används av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVVIKANDE_DATUM: {
          AttributeName: 'AVVIKANDE_DATUM',
          DisplayLabel: 'Avvikande datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AVVIKANDE_SIGN: {
          AttributeName: 'AVVIKANDE_SIGN',
          DisplayLabel: 'Avvikande signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UpdateClearingLKF: {
          AttributeName: 'UpdateClearingLKF',
          DisplayLabel: 'Skall uppdatera LKF',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PersonStatus: {
          AttributeName: 'PersonStatus',
          DisplayLabel: 'Visa status på personposten',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PrelAvliden: {
          AttributeName: 'PrelAvliden',
          DisplayLabel: 'Preliminärt avliden',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Person'],
        },
        Bolagsform: {
          AttributeName: 'Bolagsform',
          DisplayLabel: 'Bolagsform',
          Hint: 'Enskild firma/Dödsbo/Region/Utländskt bolag/Aktiebolag/Enkelt bolag/Ekonomisk förening/Stiftelse/ideell förening/Handelsbolag/kommanditbolag',
          DataType: 'Enum',
          EnumValues: new Map([['ENSKILD_FIRMA', 'Enskild firma'], ['DODSBO', 'Dödsbo'], ['REGION', 'Region'], ['UTLANDSKT_BOLAG', 'Utländskt bolag'], ['AKTIEBOLAG', 'Aktiebolag'], ['ENKELT_BOLAG', 'Enkelt bolag'], ['EKONOMISK_FORENING', 'Ekonomisk förening'], ['STIFTELSE_IDEELL_FORENING', 'Stiftelse/ideell förening'], ['HANDELSBOLAG_KOMMANDITBOLAG', 'Handelsbolag/kommanditbolag']]),
          EnumSortValues: new Map([['ENSKILD_FIRMA', '0'], ['DODSBO', '1'], ['REGION', '2'], ['UTLANDSKT_BOLAG', '3'], ['AKTIEBOLAG', '5'], ['ENKELT_BOLAG', '6'], ['EKONOMISK_FORENING', '7'], ['STIFTELSE_IDEELL_FORENING', '8'], ['HANDELSBOLAG_KOMMANDITBOLAG', '9']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ENSKILD_FIRMA=Enskild firma;DODSBO=Dödsbo;REGION=Region;UTLANDSKT_BOLAG=Utländskt bolag;AKTIEBOLAG=Aktiebolag;ENKELT_BOLAG=Enkelt bolag;EKONOMISK_FORENING=Ekonomisk förening;STIFTELSE_IDEELL_FORENING=Stiftelse/ideell förening;HANDELSBOLAG_KOMMANDITBOLAG=Handelsbolag/kommanditbolag"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Organisation',
        },
        UPPL_DATUM: {
          AttributeName: 'UPPL_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTimeGeneral',
        },
        ONLINE_DATUM: {
          AttributeName: 'ONLINE_DATUM',
          DisplayLabel: 'Uppdaterad online',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTimeGeneral',
        },
        BATCH_DATUM: {
          AttributeName: 'BATCH_DATUM',
          DisplayLabel: 'Uppdaterad av batch',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTimeGeneral',
        },
        ANV_DATUM: {
          AttributeName: 'ANV_DATUM',
          DisplayLabel: 'Ändrad av användare datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTimeGeneral',
        },
        DuplikataOrgNr: {
          AttributeName: 'DuplikataOrgNr',
          DisplayLabel: 'Duplikata organisationsnr',
          Hint: 'Visar om det finns flera organisationer med samma organisationsnummer - Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Organisation'],
          AttributeGroup: 'Organisation',
        },
        DuplikataPersonnr: {
          AttributeName: 'DuplikataPersonnr',
          DisplayLabel: 'Duplikata personnummer',
          Hint: 'Visar om det finns flera personer med samma personnummer - Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Person'],
          AttributeGroup: 'Person',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLokBlob',
          AssociatedComponentName: 'OrgPersLokBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Adress: {
          AssociationName: 'Adress',
          DisplayLabel: 'Adress',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPAdress',
          AssociatedComponentName: 'Adress',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([['NyaAvenyRequired', 'Y']]),
          Required: true,
        },
        OriginalOPL: {
          AssociationName: 'OriginalOPL',
          DisplayLabel: 'Originaladress',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPersLok',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Samfallighet: {
          AssociationName: 'Samfallighet',
          DisplayLabel: 'Församlingens pastorat',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Samfallighet',
          JoinAssociation: true,
          ValidInComps: ['Forsamling'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Vardnadshavare1: {
          AssociationName: 'Vardnadshavare1',
          DisplayLabel: 'Vårdnadshavare 1',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['Person'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Vardnadshavare2: {
          AssociationName: 'Vardnadshavare2',
          DisplayLabel: 'Vårdnadshavare 2',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['Person'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Relationsperson: {
          AssociationName: 'Relationsperson',
          DisplayLabel: 'Relationsperson',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['Person'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Gruppmedlem: {
          AssociationName: 'Gruppmedlem',
          DisplayLabel: 'Gruppmedlem',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOTEDBOGruppmedlemOP',
          AssociatedComponentName: 'GruppmedlemOP',
          JoinAssociation: true,
          ValidInComps: ['Person'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SorteringEnamn: {
          AssociationName: 'SorteringEnamn',
          DisplayLabel: 'Sortering efternamn',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPSorteringsnamn',
          AssociatedComponentName: 'Sorteringsnamn',
          JoinAssociation: true,
          ValidInComps: ['Person'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SorteringMnamn: {
          AssociationName: 'SorteringMnamn',
          DisplayLabel: 'Sortering mellannamn',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPSorteringsnamn',
          AssociatedComponentName: 'Sorteringsnamn',
          JoinAssociation: true,
          ValidInComps: ['Person'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        levkostKonto: {
          AssociationName: 'levkostKonto',
          DisplayLabel: 'Kostnadskonto',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Tvist: {
          AssociationName: 'Tvist',
          DisplayLabel: 'Tvist',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPTvist',
          AssociatedComponentName: 'Tvist',
          JoinAssociation: true,
          ValidInComps: ['Person'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Adressanvandning: {
          AssociationName: 'Adressanvandning',
          DisplayLabel: 'adressanvändning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAdressanvandning',
          AssociatedComponentName: 'Adressanvandning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Storleksklass: {
          AssociationName: 'Storleksklass',
          DisplayLabel: 'Storleksklass',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LROrgStorleksklass',
          AssociatedComponentName: 'OrgStorleksklass',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KremBest: {
          AssociationName: 'KremBest',
          DisplayLabel: 'Kremationsbeställning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBisattningKremBest',
          AssociatedComponentName: 'BisattningKremBest',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        KopiorOPL: {
          AssociationName: 'KopiorOPL',
          DisplayLabel: 'Adresskopior',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPersLok',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ExtraAdresser: {
          AssociationName: 'ExtraAdresser',
          DisplayLabel: 'Extra adresser',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPExtraAdresser',
          AssociatedComponentName: 'ExtraAdresser',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        FindRelations: {
          AssociationName: 'FindRelations',
          DisplayLabel: 'Åtagande Adress, Relationsperson',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FindVardnadshavare1: {
          AssociationName: 'FindVardnadshavare1',
          DisplayLabel: 'Åtagande Adress, Vårdnadshavare 1',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FindVardnadshavare2: {
          AssociationName: 'FindVardnadshavare2',
          DisplayLabel: 'Åtagande Adress, Vårdnadshavare 2',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FindAktDelt: {
          AssociationName: 'FindAktDelt',
          DisplayLabel: 'Åtagande Bokning, Aktivitet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktDeltagar',
          AssociatedComponentName: 'AktDeltagare',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindGruppMedlem: {
          AssociationName: 'FindGruppMedlem',
          DisplayLabel: 'Åtagande Bokning, Gruppmedlem',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOTEDBOGruppmedlemOP',
          AssociatedComponentName: 'GruppmedlemOP',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindResurs: {
          AssociationName: 'FindResurs',
          DisplayLabel: 'Åtagande Bokning, Resurs',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindAvsMot: {
          AssociationName: 'FindAvsMot',
          DisplayLabel: 'Åtagande Diarium, Mottagare/Avsändare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIAvsMot',
          AssociatedComponentName: 'Adress',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindGodman: {
          AssociationName: 'FindGodman',
          DisplayLabel: 'Åtagande Grav, God man',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'KontaktOvrig',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindGravrattsinnehavare: {
          AssociationName: 'FindGravrattsinnehavare',
          DisplayLabel: 'Åtagande Grav, Gravrättsinnehavare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'KontaktOrgPers',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindKund: {
          AssociationName: 'FindKund',
          DisplayLabel: 'Åtagande Kund',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindLeverantor: {
          AssociationName: 'FindLeverantor',
          DisplayLabel: 'Åtagande Leverantör',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindAvsandare: {
          AssociationName: 'FindAvsandare',
          DisplayLabel: 'Åtagande Diarium, avsändare på handling',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIDokument',
          AssociatedComponentName: 'DOKUMENT',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindMottagare: {
          AssociationName: 'FindMottagare',
          DisplayLabel: 'Åtagande Diarium, mottagare på handling',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIDokument',
          AssociatedComponentName: 'Dokument',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindAnvandare: {
          AssociationName: 'FindAnvandare',
          DisplayLabel: 'Åtagande, Avenyanvändare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        FindAnstalld: {
          AssociationName: 'FindAnstalld',
          DisplayLabel: 'Åtagande Anställd',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIAnstalld',
          AssociatedComponentName: 'Anstalld',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y']]),
        },
        Kontakter: {
          AssociationName: 'Kontakter',
          DisplayLabel: 'Kontaktpersoner',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPKontakt',
          AssociatedComponentName: 'Kontakt',
          JoinAssociation: false,
          ValidInComps: ['Organisation'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Forsamlingar: {
          AssociationName: 'Forsamlingar',
          DisplayLabel: 'Församlingar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Forsamling',
          JoinAssociation: false,
          ValidInComps: ['Samfallighet'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        FindForsamling: {
          AssociationName: 'FindForsamling',
          DisplayLabel: 'Åtagande Församlingar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Forsamling',
          JoinAssociation: false,
          ValidInComps: ['Samfallighet'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kursdeltagare: {
          AssociationName: 'Kursdeltagare',
          DisplayLabel: 'Kursdeltagare aktivitet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktKontakt',
          AssociatedComponentName: 'AktKontakt',
          JoinAssociation: false,
          ValidInComps: ['Organisation'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OPOrgPersLokBlob: {
      CollectionName: 'OPOrgPersLokBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OrgPersLokBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'OPOrgPersLokBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'OPOrgPersLokBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'OPOrgPersLokBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'OPOrgPersLokBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILD: {
          AttributeName: 'BILD',
          DisplayLabel: 'Bild',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Properties: new Map([['WordAttribute', 'True']]),
        },
        BILDSIZE: {
          AttributeName: 'BILDSIZE',
          DisplayLabel: 'Bild',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILDSTRETCH: {
          AttributeName: 'BILDSTRETCH',
          DisplayLabel: 'Bild',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    OPAvlidenActiveXSaml: {
      CollectionName: 'OPAvlidenActiveXSaml',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AvlidenActiveX',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: 'Avlidna Dokument',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'OPAvlidenActiveXSamls primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'OPAvlidenActiveXSamls versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'OPAvlidenActiveXSamls fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATA: {
          AttributeName: 'DATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        DATASIZE: {
          AttributeName: 'DATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UPPLAGD: {
          AttributeName: 'UPPLAGD',
          DisplayLabel: 'Upplagd',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    OPAvliden: {
      CollectionName: 'OPAvliden',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '20001']]),
      RootType: {
        TypeValue: 'Avliden',
        Abstract: false,
        SOLabel: 'Avlidna',
        SOGLabel: 'Avlidna',
        SBLabel: 'Avlidna',
        SBGLabel: 'Avlidna',
        POLabel: 'Avlidna',
        POGLabel: 'Avlidna',
        PBLabel: 'Avlidna',
        PBGLabel: 'Avlidna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Avlidna primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Avlidna versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Avlidna id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Avlidna fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARENDE_NR: {
          AttributeName: 'ARENDE_NR',
          DisplayLabel: 'Ärendenr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatArendeNr',
          GUIEditable: true,
          MaxInputLength: 11,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        P_ID: {
          AttributeName: 'P_ID',
          DisplayLabel: 'Avliden ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVLIDEN_DATUM: {
          AttributeName: 'AVLIDEN_DATUM',
          DisplayLabel: 'Dödsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          FormatterValidateParams: 'MaxDate="+0m";MaxRecommendedDate="+0m"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGR_DATUM_TID: {
          AttributeName: 'BEGR_DATUM_TID',
          DisplayLabel: 'Begravningsdatum inkl tid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTimeStr',
          GUIEditable: true,
          MaxInputLength: 16,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        INTYG_KREM_DATUM: {
          AttributeName: 'INTYG_KREM_DATUM',
          DisplayLabel: 'Kremationsintyg',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KREM_DATUM: {
          AttributeName: 'KREM_DATUM',
          DisplayLabel: 'Kremationsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit="0"',
          FormatterValidateParams: 'MaxRecommendedDate="+2m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DIREKTKREM: {
          AttributeName: 'DIREKTKREM',
          DisplayLabel: 'Direktkremation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        INTYG_DIREKTKREM_DATUM: {
          AttributeName: 'INTYG_DIREKTKREM_DATUM',
          DisplayLabel: 'Direktkremationsintyg',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        INTYG_GRAVS_DATUM: {
          AttributeName: 'INTYG_GRAVS_DATUM',
          DisplayLabel: 'Gravsättningsintyg',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MEDGIVANDE_GRAVOPPNING_DATUM: {
          AttributeName: 'MEDGIVANDE_GRAVOPPNING_DATUM',
          DisplayLabel: 'Gravöppningsintyg',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MEDGIVANDE_ML_AL_DATUM: {
          AttributeName: 'MEDGIVANDE_ML_AL_DATUM',
          DisplayLabel: 'ML/AL Intyg',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GRAVS_DATUM_TID: {
          AttributeName: 'GRAVS_DATUM_TID',
          DisplayLabel: 'Gravsättningsdatum inkl tid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTimeStr',
          GUIEditable: true,
          MaxInputLength: 16,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AKT_MED_URNA: {
          AttributeName: 'AKT_MED_URNA',
          DisplayLabel: 'Akt med urna',
          Hint: 'Akt med Urna/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'TrueText="Akt med Urna"',
          FormatterDisplayParams: 'TrueText="Akt med urna"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KREM_BEST_DATUM: {
          AttributeName: 'KREM_BEST_DATUM',
          DisplayLabel: 'Beställning av kremation',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KREM_ANNAN_ORT: {
          AttributeName: 'KREM_ANNAN_ORT',
          DisplayLabel: 'Kremering annan ort',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KREMERING: {
          AttributeName: 'KREMERING',
          DisplayLabel: 'Kremering/Jordbegravning',
          Hint: 'Kremering/Jordbegravning/Obestämd',
          DataType: 'Enum',
          EnumValues: new Map([['KREMERING', 'Kremering'], ['JORDBEGRAVNING', 'Jordbegravning'], ['OBESTAMD', 'Obestämd']]),
          EnumSortValues: new Map([['KREMERING', 'Y'], ['JORDBEGRAVNING', 'N'], ['OBESTAMD', '[BLANK]']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KREMERING=Kremering;JORDBEGRAVNING=Jordbegravning;OBESTAMD=Obestämd"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        REG_DATUM: {
          AttributeName: 'REG_DATUM',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FOSTERNUMMER: {
          AttributeName: 'FOSTERNUMMER',
          DisplayLabel: 'Personnummer saknas',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KVARTER_KGARD_ID: {
          AttributeName: 'KVARTER_KGARD_ID',
          DisplayLabel: 'Kyrkogård',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KVARTER_LOPNR: {
          AttributeName: 'KVARTER_LOPNR',
          DisplayLabel: 'Kvarter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AVDELNING_ID: {
          AttributeName: 'AVDELNING_ID',
          DisplayLabel: 'Avdelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVNUMMER: {
          AttributeName: 'GRAVNUMMER',
          DisplayLabel: 'Gravnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Gravplatsnummer',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVTYP: {
          AttributeName: 'GRAVTYP',
          DisplayLabel: 'Gravsättningstyp',
          Hint: 'Kista/Urna/Urnkammare/Nisch/Aska/Minneslund/Askgravlund/Askgravplats/Kolumbarium',
          DataType: 'Enum',
          EnumValues: new Map([['KISTA', 'Kista'], ['URNA', 'Urna'], ['URNKAMMARE', 'Urnkammare'], ['NISCH', 'Nisch'], ['ASKA', 'Aska'], ['MINNESLUND', 'Minneslund'], ['ASKGRAVLUND', 'Askgravlund'], ['ASKGRAVPLATS', 'Askgravplats'], ['KOLUMBARIUM', 'Kolumbarium']]),
          EnumSortValues: new Map([['KISTA', 'K'], ['URNA', 'U'], ['URNKAMMARE', 'R'], ['NISCH', 'N'], ['ASKA', 'A'], ['MINNESLUND', 'M'], ['ASKGRAVLUND', 'S'], ['ASKGRAVPLATS', 'G'], ['KOLUMBARIUM', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KISTA=Kista;URNA=Urna;URNKAMMARE=Urnkammare;NISCH=Nisch;ASKA=Aska;MINNESLUND=Minneslund;ASKGRAVLUND=Askgravlund;ASKGRAVPLATS=Askgravplats;KOLUMBARIUM=Kolumbarium"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVSATTNINGSORT_ID: {
          AttributeName: 'GRAVSATTNINGSORT_ID',
          DisplayLabel: 'Gravsättningsort ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BisattningID: {
          AttributeName: 'BisattningID',
          DisplayLabel: 'Bisättning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KremationID: {
          AttributeName: 'KremationID',
          DisplayLabel: 'Kremation',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BegravningID: {
          AttributeName: 'BegravningID',
          DisplayLabel: 'Begravning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GravsattningID: {
          AttributeName: 'GravsattningID',
          DisplayLabel: 'Gravsättning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGRAVNINGSPLATS: {
          AttributeName: 'BEGRAVNINGSPLATS',
          DisplayLabel: 'Begravningsplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVSPLATS: {
          AttributeName: 'GRAVSPLATS',
          DisplayLabel: 'Gravsättningsplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GravNr: {
          AttributeName: 'GravNr',
          DisplayLabel: 'Gravplatsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Kvarter: {
          AttributeName: 'Kvarter',
          DisplayLabel: 'Benämning kyrkogård/kvarter/avdelning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GravNrFullt: {
          AttributeName: 'GravNrFullt',
          DisplayLabel: 'Gravplatsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravplatsnummer',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GravID: {
          AttributeName: 'GravID',
          DisplayLabel: 'Grav',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BegrDatum: {
          AttributeName: 'BegrDatum',
          DisplayLabel: 'Begravningsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GravsDatum: {
          AttributeName: 'GravsDatum',
          DisplayLabel: 'Gravsättningsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BegravningsTid: {
          AttributeName: 'BegravningsTid',
          DisplayLabel: 'Begravningstid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GravsattningsTid: {
          AttributeName: 'GravsattningsTid',
          DisplayLabel: 'Gravsättningstid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          InterfaceType: 'ifNone',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SKICKAT_GRAVSINTYG: {
          AttributeName: 'SKICKAT_GRAVSINTYG',
          DisplayLabel: 'Skickat gravsättningsintyg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKICKAT_KREMINTYG: {
          AttributeName: 'SKICKAT_KREMINTYG',
          DisplayLabel: 'Skickat kremationsintyg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AntalRef: {
          AttributeName: 'AntalRef',
          DisplayLabel: 'Antal referenser',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKICKAT_KREMINTYG_MANUELLT: {
          AttributeName: 'SKICKAT_KREMINTYG_MANUELLT',
          DisplayLabel: 'Skickat kremationsintyg manuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKICKAT_GRAVSINTYG_MANUELLT: {
          AttributeName: 'SKICKAT_GRAVSINTYG_MANUELLT',
          DisplayLabel: 'Skickat gravsättningsintyg manuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REDAN_GRAVSATT: {
          AttributeName: 'REDAN_GRAVSATT',
          DisplayLabel: 'Redan gravsatt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        REDAN_KREMERAD: {
          AttributeName: 'REDAN_KREMERAD',
          DisplayLabel: 'Redan kremerad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        TvistID: {
          AttributeName: 'TvistID',
          DisplayLabel: 'Tvist (aktiv i första hand)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalDagarGravs: {
          AttributeName: 'AntalDagarGravs',
          DisplayLabel: 'Dagar Döds-gravs',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Person: {
          AssociationName: 'Person',
          DisplayLabel: 'Avliden info',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'PERS_NR,OP_Namn,Namn,NamnFE,NamnEFF,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,LKF,LKF_BENAMNING,KYRKOLKF,KYRKOLKF_BENAMNING,LKFStatus,Forsamlingsbo,AVLIDEN_STATUS,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.ADRESS,Adress.CO,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,MEDLEMSKOD,Tvist.TVIST_GRAVS,Tvist.TVIST_KREM;'], ['OverrideDisplayLabels', 'PERS_NR="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:*="Avliden",PREFIX:*="";'], ['NOT_ATAGANDE', 'Y']]),
          Required: true,
        },
        Bisattning: {
          AssociationName: 'Bisattning',
          DisplayLabel: 'Bisättningsjournal',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBisattning',
          AssociatedComponentName: 'Bisattningsjournal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['IntegratedFilter', 'HandelseStatus,HandelseDatum;'], ['OverrideDisplayLabels', ' ,G:*="Bisättning",PREFIX:*="Bisättning ";'], ['NOT_ATAGANDE', 'Y']]),
        },
        Tvist: {
          AssociationName: 'Tvist',
          DisplayLabel: 'Tvist',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPTvist',
          AssociatedComponentName: 'Tvist',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gravsattning: {
          AssociationName: 'Gravsattning',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Gravsattning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kremation: {
          AssociationName: 'Kremation',
          DisplayLabel: 'Kremationsjournal',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KJKremation',
          AssociatedComponentName: 'Kremationsjournal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gravsatt: {
          AssociationName: 'Gravsatt',
          DisplayLabel: 'Gravsatt',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGravsatt',
          AssociatedComponentName: 'Gravsatt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Begravning: {
          AssociationName: 'Begravning',
          DisplayLabel: 'Begravning',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Begravning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gravsattningsort: {
          AssociationName: 'Gravsattningsort',
          DisplayLabel: 'Gravsättningsort',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Organisation',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KGard: {
          AssociationName: 'KGard',
          DisplayLabel: 'Kyrkogård',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKGard',
          AssociatedComponentName: 'KGard',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kvarter: {
          AssociationName: 'Kvarter',
          DisplayLabel: 'Kyrkogård och kvarter',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKvarter',
          AssociatedComponentName: 'Kvarter',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['OverrideDisplayLabels', 'BENAMNING="Kvarter, benämning",SafeBenamning="Kvarter, benämning eller kod",KodBenamning="Kvarter, kod och benämning",G:*="Gravplatsnummer";']]),
        },
        Avdelning: {
          AssociationName: 'Avdelning',
          DisplayLabel: 'Avdelning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAAvdelning',
          AssociatedComponentName: 'Avdelning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['OverrideDisplayLabels', 'BENAMNING="Avdelning, benämning",SafeBenamning="Avdelning, benämning eller kod",KodBenamning="Avdelning, kod och benämning",G:*="Gravplatsnummer";']]),
        },
        Dodsbo: {
          AssociationName: 'Dodsbo',
          DisplayLabel: 'Dödsbo',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Dodsbo',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPAvlidenActiveXSaml',
          AssociatedComponentName: 'AvlidenActiveX',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OPExtraAdresser: {
      CollectionName: 'OPExtraAdresser',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ExtraAdresser',
        Abstract: false,
        SOLabel: 'Adress',
        SOGLabel: 'Adress',
        SBLabel: 'Adressen',
        SBGLabel: 'Adressen',
        POLabel: 'Adresser',
        POGLabel: 'Adresser',
        PBLabel: 'Adresserna',
        PBGLabel: 'Adresserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Adressen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Adressen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Adressen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Adressen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KATEGORI: {
          AttributeName: 'KATEGORI',
          DisplayLabel: 'Kategori',
          Hint: 'Borttagen/Särskild adress/Utlandsadress/Folkbokföringsadress',
          DataType: 'Enum',
          EnumValues: new Map([['BORTTAGEN', 'Borttagen'], ['SARSKILD_ADRESS', 'Särskild adress'], ['UTLANDSADRESS', 'Utlandsadress'], ['FOLKBOKFORINGSADRESS', 'Folkbokföringsadress']]),
          EnumSortValues: new Map([['BORTTAGEN', 'B'], ['SARSKILD_ADRESS', 'S'], ['UTLANDSADRESS', 'U'], ['FOLKBOKFORINGSADRESS', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BORTTAGEN=Borttagen;SARSKILD_ADRESS=Särskild adress;UTLANDSADRESS=Utlandsadress;FOLKBOKFORINGSADRESS=Folkbokföringsadress"',
          InterfaceType: 'ifChecklist',
        },
        ADR_ID: {
          AttributeName: 'ADR_ID',
          DisplayLabel: 'Adress',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INTERN_KOD: {
          AttributeName: 'INTERN_KOD',
          DisplayLabel: 'Intern kod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        OrgPers: {
          AssociationName: 'OrgPers',
          DisplayLabel: 'Adress till',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPersLok',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['OPL_NOCOMBINE', 'True'], ['NOT_ATAGANDE', 'Y']]),
        },
        Adress: {
          AssociationName: 'Adress',
          DisplayLabel: 'Adress',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPAdress',
          AssociatedComponentName: 'Adress',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    OPTEDOPKategori: {
      CollectionName: 'OPTEDOPKategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kategori',
        Abstract: false,
        SOLabel: 'Kategori',
        SOGLabel: 'Kategori',
        SBLabel: 'Kategorin',
        SBGLabel: 'Kategorin',
        POLabel: 'Kategorier',
        POGLabel: 'Kategorier',
        PBLabel: 'Kategorierna',
        PBGLabel: 'Kategorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kategorin primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kategorin versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kategorin id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kategorin fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    OPKontakt: {
      CollectionName: 'OPKontakt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '8009']]),
      RootType: {
        TypeValue: 'Kontakt',
        Abstract: false,
        SOLabel: 'Kontaktperson',
        SOGLabel: 'Kontaktperson',
        SBLabel: 'Kontaktpersonen',
        SBGLabel: 'Kontaktpersonen',
        POLabel: 'Kontaktpersoner',
        POGLabel: 'Kontaktpersoner',
        PBLabel: 'Kontaktpersonerna',
        PBGLabel: 'Kontaktpersonerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontaktpersonen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontaktpersonen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kontaktpersonen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontaktpersonen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ADR_ID: {
          AttributeName: 'ADR_ID',
          DisplayLabel: 'Adress',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        NOTERINGAR: {
          AttributeName: 'NOTERINGAR',
          DisplayLabel: 'Noteringar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVDELNING: {
          AttributeName: 'AVDELNING',
          DisplayLabel: 'Avdelning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Titlar: {
          AttributeName: 'Titlar',
          DisplayLabel: 'Titlar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Yes;']]),
        },
        Tele: {
          AttributeName: 'Tele',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Telefon2: {
          AttributeName: 'Telefon2',
          DisplayLabel: 'Telefon 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kundid: {
          AttributeName: 'Kundid',
          DisplayLabel: 'Kundid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Epost: {
          AttributeName: 'Epost',
          DisplayLabel: 'Epost',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KompaktAdress: {
          AttributeName: 'KompaktAdress',
          DisplayLabel: 'Kompaktadress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fax: {
          AttributeName: 'Fax',
          DisplayLabel: 'Fax',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Mobiltelefon: {
          AttributeName: 'Mobiltelefon',
          DisplayLabel: 'Mobiltelefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Arbetstelefon: {
          AttributeName: 'Arbetstelefon',
          DisplayLabel: 'Arbetstelefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Gatuadress: {
          AttributeName: 'Gatuadress',
          DisplayLabel: 'Gatuadress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Sortering: {
          AttributeName: 'Sortering',
          DisplayLabel: 'Sortering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PERS_NR: {
          AttributeName: 'PERS_NR',
          DisplayLabel: 'Personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatPersNr',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Id, användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Adress: {
          AssociationName: 'Adress',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPAdress',
          AssociatedComponentName: 'Adress',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
        OrgPers: {
          AssociationName: 'OrgPers',
          DisplayLabel: 'Kontakt för',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['OPL_NOCOMBINE', 'True'], ['NOT_ATAGANDE', 'Y']]),
        },
        Kontaktkund: {
          AssociationName: 'Kontaktkund',
          DisplayLabel: 'Kontaktkund',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Titlar: {
          AssociationName: 'Titlar',
          DisplayLabel: 'Titlar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPKontaktTitel',
          AssociatedComponentName: 'KontaktTitel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        KontaktLicens: {
          AssociationName: 'KontaktLicens',
          DisplayLabel: 'Kontaktlicens',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRLicenser',
          AssociatedComponentName: 'Licenser',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktKontakt: {
          AssociationName: 'AktKontakt',
          DisplayLabel: 'Kontakt på en aktivitet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktKontakt',
          AssociatedComponentName: 'AktKontakt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OPSorteringsnamn: {
      CollectionName: 'OPSorteringsnamn',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Sorteringsnamn',
        Abstract: false,
        SOLabel: 'Sorteringsnamn',
        SOGLabel: 'Sorteringsnamn',
        SBLabel: 'Sorteringsnamnet',
        SBGLabel: 'Sorteringsnamnet',
        POLabel: 'Sorteringsnamn',
        POGLabel: 'Sorteringsnamn',
        PBLabel: 'Sorteringsnamnen',
        PBGLabel: 'Sorteringsnamnen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Sorteringsnamnet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Sorteringsnamnet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Sorteringsnamnet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Sorteringsnamnet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SORTERINGSNAMN: {
          AttributeName: 'SORTERINGSNAMN',
          DisplayLabel: 'Sorteringsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 60,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    OPKontaktTitel: {
      CollectionName: 'OPKontaktTitel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '7016']]),
      RootType: {
        TypeValue: 'KontaktTitel',
        Abstract: false,
        SOLabel: 'Titel',
        SOGLabel: 'Titel',
        SBLabel: 'Titeln',
        SBGLabel: 'Titeln',
        POLabel: 'Titlar',
        POGLabel: 'Titlar',
        PBLabel: 'Titlarna',
        PBGLabel: 'Titlarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Titeln primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Titeln versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Titeln id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Titeln fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TITEL_ID: {
          AttributeName: 'TITEL_ID',
          DisplayLabel: 'Titel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Titel: {
          AttributeName: 'Titel',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Titel: {
          AssociationName: 'Titel',
          DisplayLabel: 'Titel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSTitel',
          AssociatedComponentName: 'Titel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
        Kontakt: {
          AssociationName: 'Kontakt',
          DisplayLabel: 'Kontaktperson',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPKontakt',
          AssociatedComponentName: 'Kontakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OPTvistHist: {
      CollectionName: 'OPTvistHist',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'TvistHist',
        Abstract: false,
        SOLabel: 'Tvistehistorik',
        SOGLabel: 'Tvistehistoriks',
        SBLabel: 'Tvistehistoriken',
        SBGLabel: 'Tvistehistorikens',
        POLabel: 'Tvistehistorik',
        POGLabel: 'Tvistehistoriks',
        PBLabel: 'Tvistehistoriken',
        PBGLabel: 'Tvistehistorikens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tvistehistorikens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tvistehistorikens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tvistehistorikens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANDRAD_DATUM: {
          AttributeName: 'ANDRAD_DATUM',
          DisplayLabel: 'Ändringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        ANDRAD_SIGNATUR: {
          AttributeName: 'ANDRAD_SIGNATUR',
          DisplayLabel: 'Ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AVSER: {
          AttributeName: 'AVSER',
          DisplayLabel: 'Avser tvist',
          Hint: 'Gravsättning/Kremering/Samtliga',
          DataType: 'Enum',
          EnumValues: new Map([['GRAVSATTNING', 'Gravsättning'], ['KREMERING', 'Kremering'], ['SAMTLIGA', 'Samtliga']]),
          EnumSortValues: new Map([['GRAVSATTNING', 'G'], ['KREMERING', 'K'], ['SAMTLIGA', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GRAVSATTNING=Gravsättning;KREMERING=Kremering;SAMTLIGA=Samtliga"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        ORSAK: {
          AttributeName: 'ORSAK',
          DisplayLabel: 'Orsak',
          Hint: 'Tillägg/Ändring/Borttag',
          DataType: 'Enum',
          EnumValues: new Map([['TILLAGG', 'Tillägg'], ['ANDRING', 'Ändring'], ['BORTTAG', 'Borttag']]),
          EnumSortValues: new Map([['TILLAGG', 'T'], ['ANDRING', 'A'], ['BORTTAG', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TILLAGG=Tillägg;ANDRING=Ändring;BORTTAG=Borttag"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Tvist: {
          AssociationName: 'Tvist',
          DisplayLabel: 'Tvist',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPTvist',
          AssociatedComponentName: 'Tvist',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    OPTvist: {
      CollectionName: 'OPTvist',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Tvist',
        Abstract: false,
        SOLabel: 'Tvist',
        SOGLabel: 'Tvists',
        SBLabel: 'Tvisten',
        SBGLabel: 'Tvistens',
        POLabel: 'Tvister',
        POGLabel: 'Tvisters',
        PBLabel: 'Tvisterna',
        PBGLabel: 'Tvisternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tvistens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tvistens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Tvistens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tvistens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERS_NR: {
          AttributeName: 'PERS_NR',
          DisplayLabel: 'Personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPersNr',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          Required: true,
          MaskedValue: true,
        },
        TVIST_KREM: {
          AttributeName: 'TVIST_KREM',
          DisplayLabel: 'Tvist gäller kremering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        TVIST_GRAVS: {
          AttributeName: 'TVIST_GRAVS',
          DisplayLabel: 'Tvist gäller gravsättning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        OFFENTLIG_NOTERING: {
          AttributeName: 'OFFENTLIG_NOTERING',
          DisplayLabel: 'Offentlig notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        INTERN_NOTERING: {
          AttributeName: 'INTERN_NOTERING',
          DisplayLabel: 'Intern notering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 125,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SenastAndrad: {
          AttributeName: 'SenastAndrad',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FORBEHALL: {
          AttributeName: 'FORBEHALL',
          DisplayLabel: 'Förbehåll',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GUID: {
          AttributeName: 'GUID',
          DisplayLabel: 'GUID',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINTKREM: {
          AttributeName: 'HINTKREM',
          DisplayLabel: 'Hint Kremation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        HINTGRAVS: {
          AttributeName: 'HINTGRAVS',
          DisplayLabel: 'Hint Gravsättning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Avliden: {
          AssociationName: 'Avliden',
          DisplayLabel: 'Avliden',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPAvliden',
          AssociatedComponentName: 'Avliden',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Historik: {
          AssociationName: 'Historik',
          DisplayLabel: 'Historik',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPTvistHist',
          AssociatedComponentName: 'TvistHist',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
  },
};

export default OP;
